const StraightLine = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="5"
      height="70"
      viewBox="0 0 5 70"
      fill="none"
    >
      <path
        d="M2.5 67.5L2.5 2.5"
        stroke="url(#gradient)"
        strokeWidth="5"
        strokeLinecap="square"
      />

      <defs>
        <linearGradient
          id="gradient"
          x1="0"
          y1="0"
          x2="0"
          y2="70"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0%" stopColor="#DFDFDF">
            <animate
              attributeName="offset"
              values="-1;1"
              dur="2s"
              repeatCount="indefinite"
            />
          </stop>

          <stop offset="50%" stopColor="#2D65F2">
            <animate
              attributeName="offset"
              values="0;2"
              dur="2s"
              repeatCount="indefinite"
            />
          </stop>

          <stop offset="100%" stopColor="#FFFFFF">
            <animate
              attributeName="offset"
              values="1;3"
              dur="2s"
              repeatCount="indefinite"
            />
          </stop>
        </linearGradient>
      </defs>
    </svg>
  );
};

export default StraightLine;
